import React from 'react';

import SectionContainer from '../containers/SectionContainer';
import StepContainer from '../containers/StepContainer';

import Step7 from './Step7';
import Step8a from './Step8a';
import Step8b from './Step8b';
import Step9 from './Step9';

const Section3 = ({
	stepsPending,
	estimatedTime,
	progress,
	isActive,
	isComplete,
	onSectionClick,
	stepStates,
	toggleStepDisplay,
	onStepCompletion,
	onStepSkip,
	...rest
}) => {
	return (
		<SectionContainer
			iconType="audit"
			sectionIndex={2}
			sectionTitle="Airlines information"
			stepsPending={stepsPending}
			estimatedTime={estimatedTime}
			progress={progress}
			isActive={isActive}
			isComplete={isComplete}
			onSectionClick={onSectionClick}
		>
			<StepContainer
				stepTitle="TMC UI"
				stepCounter="1"
				stepState={stepStates[0]}
				toggleStepDisplay={toggleStepDisplay(2, 0)}
				isChildActive={stepStates
					.map(state => state.isActive)
					.some(value => value === true)}
			>
				<Step7
					isInOnboarding={true}
					stepState={stepStates[0]}
					onStepCompletion={onStepCompletion(2, 0)}
					onStepSkip={onStepSkip(2, 0)}
					{...rest}
				/>
			</StepContainer>
			<StepContainer
				stepTitle="Airline Authorization"
				stepCounter="2"
				stepState={stepStates[1]}
				toggleStepDisplay={toggleStepDisplay(2, 1)}
				isChildActive={stepStates
					.map(state => state.isActive)
					.some(value => value === true)}
			>
				<Step8a
					isInOnboarding={true}
					stepState={stepStates[1]}
					onStepCompletion={onStepCompletion(2, 1)}
					onStepSkip={onStepSkip(2, 1)}
					{...rest}
				/>
			</StepContainer>
			<StepContainer
				stepTitle="Airline Contact"
				stepCounter="3"
				stepState={stepStates[2]}
				toggleStepDisplay={toggleStepDisplay(2, 2)}
				isChildActive={stepStates
					.map(state => state.isActive)
					.some(value => value === true)}
			>
				<Step8b
					isInOnboarding={true}
					stepState={stepStates[2]}
					onStepCompletion={onStepCompletion(2, 2)}
					onStepSkip={onStepSkip(2, 2)}
					{...rest}
				/>
			</StepContainer>
			<StepContainer
				stepTitle="Air India Login"
				stepCounter="4"
				stepState={stepStates[3]}
				toggleStepDisplay={toggleStepDisplay(2, 3)}
				isChildActive={stepStates
					.map(state => state.isActive)
					.some(value => value === true)}
			>
				<Step9
					isInOnboarding={true}
					stepState={stepStates[3]}
					onStepCompletion={onStepCompletion(2, 3)}
					onStepSkip={onStepSkip(2, 3)}
					{...rest}
				/>
			</StepContainer>
		</SectionContainer>
	);
};

export default Section3;
